import { useState } from "react";
import { stampPdfPacket } from "../../js/api/filePacket";
import { buildFilePacketModel } from "../../js/export/filePacketModel";
import { reportFileStem } from "../../js/export/reportModel";
import { useAuth } from "../../js/hooks/useAuth";

export default function FilePdfButton({ file, onSaved, className = "primary-btn" }) {
  const { session } = useAuth();
  const [busy, setBusy] = useState(false);
  const [notice, setNotice] = useState("");

  if (!file?.id) return null;

  async function handleExport() {
    setBusy(true);
    setNotice("");
    const model = buildFilePacketModel(file, { generatedBy: session?.name });
    const stem = reportFileStem(file.propertyAddress || file.clientProfile?.name);
    const filename = `dreamhome-${stem}-file-packet.pdf`;
    try {
      const { downloadReportPdf } = await import("../../js/export/reportPdf");
      downloadReportPdf(model, filename);
      stampPdfPacket(file.id, session, filename);
      setNotice("File packet PDF downloaded.");
      onSaved?.();
    } catch {
      try {
        const { renderReportHtml } = await import("../../js/export/reportHtml");
        const html = renderReportHtml(model);
        const blob = new Blob([html], { type: "text/html" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `dreamhome-${stem}-file-packet.html`;
        link.click();
        URL.revokeObjectURL(url);
        stampPdfPacket(file.id, session, `${stem}-file-packet.html`);
        setNotice("PDF was unavailable, so the file packet was saved as HTML.");
        onSaved?.();
      } catch {
        setNotice("The file packet could not be generated.");
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="file-pdf-actions">
      <button type="button" className={className} onClick={handleExport} disabled={busy}>
        {busy ? "Preparing packet…" : "Download file packet PDF"}
      </button>
      {notice ? <p className="muted">{notice}</p> : null}
    </div>
  );
}
